import styled from 'styled-components';

import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';

import { pxToRem } from 'utils/convert';

import { CHECKBOX_STATUS } from 'ui/checkbox/checkboxStatus';
import { HeaderGridRow } from 'ui/indexPages/tables/grid';
import { GroupSelect } from 'ui/indexPages/tables/groupSelect';

import { TABLE_COLUMNS, TABLE_GRID } from '../../constants';

import { HeaderRowCell } from './HeaderRowCell';

const displayText = {
  [TABLE_COLUMNS.NAME]: 'Name',
  [TABLE_COLUMNS.STATUS]: 'Status',
  [TABLE_COLUMNS.ENTRY_SOURCE]: 'Entry source',
  [TABLE_COLUMNS.LAST_MODIFIED]: 'Last modified',
  [TABLE_COLUMNS.SEND_ACTIVITY]: 'Send activity',
};

const columns = [
  {
    id: TABLE_COLUMNS.NAME,
    label: displayText[TABLE_COLUMNS.NAME],
    isSortable: true,
    initialSortDirection: SORT_DIRECTIONS.ASCENDING,
  },
  {
    id: TABLE_COLUMNS.STATUS,
    label: displayText[TABLE_COLUMNS.STATUS],
    isSortable: true,
  },
  {
    id: TABLE_COLUMNS.ENTRY_SOURCE,
    label: displayText[TABLE_COLUMNS.ENTRY_SOURCE],
    isSortable: false,
  },
  {
    id: TABLE_COLUMNS.SEND_ACTIVITY,
    label: displayText[TABLE_COLUMNS.SEND_ACTIVITY],
    isSortable: false,
  },
  {
    id: TABLE_COLUMNS.LAST_MODIFIED,
    label: displayText[TABLE_COLUMNS.LAST_MODIFIED],
    isSortable: true,
  },
];

export const StyledGroupSelect = styled(GroupSelect)`
  margin-left: -${pxToRem(9)};
`;

type HeaderRowProps = {
  deselectAll: () => void;
  groupSelectStatus: CHECKBOX_STATUS;
  selectAll: () => void;
  sortedBy: TABLE_COLUMNS;
  setSortedBy: (sortedBy: TABLE_COLUMNS) => void;
  sortDirection: SORT_DIRECTIONS;
  setSortDirection: (sortDirection: SORT_DIRECTIONS) => void;
  isGroupSelectionDisabled: boolean;
};

export const HeaderRow = ({
  deselectAll,
  groupSelectStatus,
  selectAll,
  sortedBy,
  setSortedBy,
  sortDirection,
  setSortDirection,
  isGroupSelectionDisabled,
}: HeaderRowProps) => {
  return (
    <HeaderGridRow gridLayout={TABLE_GRID}>
      <StyledGroupSelect
        onSelectAll={selectAll}
        onSelectNone={deselectAll}
        status={groupSelectStatus}
        isDisabled={isGroupSelectionDisabled}
      />
      {columns.map((column) => (
        <HeaderRowCell
          column={column}
          key={column.id}
          isActiveSortColumn={column.id === sortedBy}
          sortDirection={sortDirection}
          setSortDirection={setSortDirection}
          setSortedBy={setSortedBy}
        />
      ))}
      <div data-test="placeholder-column-for-action-button" />
    </HeaderGridRow>
  );
};
